module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/a933b8b20f7473854252589b22ed8319.png";